<span>
  <i matTooltip="Clear" matTooltipPosition="above" *ngIf="editable" class="clear-rating fas text-secondary fa-fw fa-lg fa-ban cursor-pointer" (click)="clearRating()"></i>
  <i [matTooltip]="getTitle(n)" matTooltipPosition="above" (click)="select(n)" (mouseleave)="clearHover()" (mouseenter)="setHover(n)" class="outline p-1" [ngClass]="getStyle(n)" *ngFor="let number of ratingsArray; let n = index;"></i>
</span>
